export default "__VITE_ASSET__ClkrximE__"